<template>
    <v-card rounded="lg"  class="pa-3 px-2 retroplanningContactList">
        <div v-if="loader" class="loaderUpload">
            <v-progress-circular
                :size="50"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        </div>
        <v-card-title class="retroTitle" v-if="!limitRetro" v-show="retroplanning.config.name">
            <b>{{retroplanning.config.name}} ({{this.parseFullDateToFr(retroplanning.config.date_start).slice(0, 5)}}<span v-if="retroplanning.config.date_end"> {{$t('to')+" "+this.parseFullDateToFr(retroplanning.config.date_end).slice(0, 5)}}</span>)</b>
        </v-card-title>
        <v-card-text class="pt-3">
            <h2 v-if="limitRetro" class="mb-5" style="min-height:unset;">{{$t('recipients')}}</h2>
            <v-alert class="mb-0  mb-2" border="left" :icon="'$warning_s'" color="warning" text v-if="retroplanning.config.contact_number && retroplanning.config.contact_number > 10000 && sousType == 'campVMSout'">
                {{ $t("CampaignMustBeProgrammed24hoursBefore") }}
            </v-alert>
            <v-alert class="mb-0  mb-2" border="left" color="warning" text v-if="retroplanning.config.contact_list_hydrat && retroplanning.config.contact_list_hydrat == 0">
                {{ $t("noDestinataireSelected") }}
            </v-alert>
            <v-card color="lightgrey" class="no-shadow mb-2" v-else v-for="contactlist in retroplanning.config.contact_list_hydrat" :key="'contactlist_'+retroplanning.id+'_'+contactlist.id" @click="openStats(contactlist)" :style="retroplanning.status === 'COMPLETED' ? 'cursor: default;' : ''">
                <v-card-title class="justify-space-between">
                    <div class="contactListTitle">
                        <b>{{contactlist.name}} <v-chip :color="contactlist.type == 'STATIC' ? 'primary' : (contactlist.type == 'RENTAL' ? 'secondary' : 'pink')" class="ml-3" dark small>{{$t(contactlist.type)}}</v-chip></b>
                        <div>{{contactlist.entity_name}}</div> 
                    </div>
                    <span class="d-flex align-center" v-if="retroplanning.status !== 'COMPLETED'">
                        <div class="contactListContactCount">
                            <span v-if="contactlist.status == 'ON_GOING'">{{ $t("on_going") }}</span>
                            <span v-else><b>{{contactlist.contact_count}}</b> Contacts</span>
                        </div>
                        <v-btn text class="square ml-2" @click.stop="removeListFromLP(contactlist, retroplanning)" v-if="!fromPresta && (!retroplanning.status || (retroplanning.status && !['PROGRAMMED', 'COMPLETED', 'ON_GOING'].includes(retroplanning.status))) && $func.hasRight('contactlist/delete')">
                            <v-icon small color="black" >$close</v-icon>
                        </v-btn>
                    </span>
                </v-card-title>
            </v-card>
        </v-card-text>
        <v-card-actions class="px-4 pt-0" v-if="['DRAFT', 'PROVIDER_REFUSAL'].includes(retroplanning.status)">
            <v-btn class="bg-gradient" depressed v-if="!limitRetro && !fromPresta && (!retroplanning.status || (retroplanning.status && !['PROGRAMMED', 'COMPLETED'].includes(retroplanning.status)) || (retroplanning.status == 'PROGRAMMED' && retroplanning.config.type == 'CAMP_CALL')) && $func.hasRight('contactlist/add')" @click="$emit('addList', retroplanning.config.contact_list)">{{$t('addlist')}}</v-btn>
            <v-btn class="pink" dark depressed v-if="limitRetro && ['CAMP_OUT_P', 'CAMP_CALL'].includes(retroplanning.type) && retroplanning.config.contact_enrichable > 0 && $func.hasRight('contact/enrich') && deliverabilityPercent > 0" @click="getForm('/contactlist/getFormEnrichment?retroplanning_id=' + retroplanning.id)">{{ $t('increase_deliverability_by_x', { nb: deliverabilityPercent }) }}</v-btn>
            <v-spacer></v-spacer>
            <p class="mb-0 d-flex align-center" v-if="retroplanning.config && retroplanning.config.hasOwnProperty('contact_number') && retroplanning.config.hasOwnProperty('contact_number_total')">
                <b>{{$t('estimatedContacts')}}</b> 
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon color='primary' class="mx-2" v-bind="attrs" v-on="on">$circleinfo_d</v-icon> 
                    </template>
                    <span v-html="$t('contactListEstimatedCountLabel')"></span>
                </v-tooltip>
                <b style="font-size:20px">{{retroplanning.config.contact_number}} / {{ totalContactNumber }} </b>
            </p>
        </v-card-actions>

        <dialogStatsContactComponent v-if="openDialogStats" @closeStatsContactDialog="openDialogStats = false" :openDialogStats="openDialogStats" :id="contactlistId" :retroplanning_id="retroplanning.id" :idType="'contactlist_id'" />
        <ConfirmDialogComponent ref="confirmDialog" />
        <FormDialogComponent v-if="form" ref="componentForm" :form="form" :action="'SET_DATA'"/>
    </v-card>
</template>
<script>
import dateManipulation from '@/mixins/dateManipulation'
import getForm from "@/mixins/mixins";
import dialogStatsContactComponent from '@/components/dialogs/dialogStatsContactComponent';
import ConfirmDialogComponent from "@/components/dialogs/ConfirmDialogComponent";

export default {
    name:"retroplanningContactListComponent",
    props: ['retroplanning', 'loader', 'limitRetro', 'sousType', 'fromPresta'],
    components: { 
        dialogStatsContactComponent, 
        ConfirmDialogComponent, 
        FormDialogComponent: () => import("@/components/dialogs/FormDialogComponent"),
    },
    mixins: [getForm, dateManipulation],
    data() {
        return {
            openDialogStats: false,
            contactlistId: null,
            form: null,
        }
    },
    watch: {
        loader(val){
        }
    },
    computed: {
        deliverabilityPercent() {
            return Math.round((((this.retroplanning.config.contact_enrichable + this.retroplanning.config.contact_number) - this.retroplanning.config.contact_number) / this.retroplanning.config.contact_number) * 100);
        },

        totalContactNumber() {
            if (this.retroplanning.config.prevision_limit && this.retroplanning.config.sending_vol < this.retroplanning.config.contact_number_total)
                return this.retroplanning.config.sending_vol;
            else 
                return this.retroplanning.config.contact_number_total;
        },
    },
    methods: {
        openStats(item) {
            if(item.type != 'RENTAL' && !this.fromPresta && this.retroplanning.status !== 'COMPLETED') {
                this.contactlistId = item.id;
                this.openDialogStats = true;
            }
        },
        removeListFromLP(contactlist, retroplanning) {
            if(contactlist.type === 'RENTAL') {
                this.removeListFromLPAsync(contactlist, retroplanning);
            } else {
                this.$emit('removeListFromLP', contactlist.id, retroplanning);
            }
        },
        async removeListFromLPAsync(contactlist, retroplanning) {
            if (await this.$refs.confirmDialog.open(this.$t("confirmDeleteProfiliaContactListTitle"), this.$t("confirmDeleteProfiliaContactListMessage"))) {
                this.$emit('removeListFromLP', contactlist.id, retroplanning);
            }
        },
        customRefresh() {
            this.$emit('refreshData');
        },
    }
}
</script>
<style lang="scss">
    .retroplanningContactList {
        .retroTitle, .contactListTitle, .contactListContactCount {
            b {
                font-weight: 900;
            }
        }
    }
    .loaderUpload {
            width: 100%;
            height: 100%;
            position:absolute;
            display:flex;
            justify-content: center;
            align-items: center;
            z-index:1000;
            top:0;
            left:0;
            background-color:rgba(255,255,255,0.7)
        }
</style>